import type { LetterCharacter, LetterState, PlayerId } from '../types';
import { LETTER_VALUES } from '../constants/letterValues';
import { generateId } from '../../utils/uuid';

export interface Letter {
  id: string; // Unique instance ID (UUID)
  character: LetterCharacter; // A-Z
  state: LetterState; // Where the letter currently is
  owner: PlayerId | null; // Which player holds it (if in hand)
  points: number; // Scrabble-style point value (A=1, Q=10, etc.)
}

/**
 * Create a new letter instance
 */
export function createLetter(
  character: LetterCharacter,
  state: LetterState = 'pool',
  owner: PlayerId | null = null
): Letter {
  return {
    id: generateId(),
    character,
    state,
    owner,
    points: LETTER_VALUES[character],
  };
}

/**
 * Update letter state
 */
export function updateLetterState(
  letter: Letter,
  newState: LetterState,
  newOwner: PlayerId | null = null
): Letter {
  return {
    ...letter,
    state: newState,
    owner: newOwner,
  };
}
